function rk_helloWorld(){
        //console.log("/n****** hello RUGKOP world /n******");
    }

// adds jquery module if it isnt already loaded
function rk_addExternals(){
    if (!window.jQuery){
        var jq = document.createElement("script");
        jq.type = "text/javascript";
        jq.src = "https://code.jquery.com/jquery-3.7.1.min.js";
        document.getElementsByTagName("head")[0].appendChild(jq);
        //console.log("Added jQuery!");
    } else {
        //console.log("jQuery already exists.")
    }
}


    // rk_findInitialBsubElements
// this function finds known visible elements from the Bold subscription mdoule and toggles them off.
// it first get a handle on a unique element with ID "#customer-portal-root".
// the elements in question are then toggled off based on the relative position to this specific element
// they are toggled off only they have the correct inner html, (i.e correct visible tag in either UK or danish)
function rk_findInitialBsubElements(){
  var somethingToFind = "#customer-portal-root"; // OK Shopify domain // ID jQuery syntax
  var elm = $( somethingToFind );//jQuery
  var tmp;
  if(elm){
   
    // *************
    //.next-order-date-edit-resume-button
    // *************
    rk_applyAddedFunctionalityTonNextOrderDateEditResumeButton();

    elm = $(".bsub__address-header");
    //console.log("html bsub__address-header", elm.html());
    //elm.css("border", "3px solid yellow");//jQuery

    // *************
    // shipping adress
    // *************    
    elm = elm.parent();
    //elm.css("border", "3px solid red");//jQuery
    elm.css("display", "none");


    // *************
    // add products button
    // *************
    elm = elm.prev();
    //elm.css("border", "3px solid red");//jQuery
    elm.on("click", rk_bsubAddProductsButtonClicked);//onone


    elm = elm.parent();
    //elm.css("border", "3px solid green");//jQuery

    elm = elm.next();
    //elm.css("border", "3px solid green");//jQuery
    
    // *************
    // payment details
    // *************
    elm = elm.children().first();
    //elm.css("border", "3px solid red");//jQuery
    elm.css("display", "none");

    // *******************
    // Products in my subscription / Varer i mit abonnement
    // >> move to first position
    // >> remove Edit link and Swap Links
    // >> try to expand accordion
    // *******************    
    elm = $(".products-panel-wrap");
    //elm.css("border", "3px solid green");//jQuery
    elm.on("click", rk_bsubProductsInMySubscriptionAccordionClickListener);//onone
    //elm = elm.detach();
    elm = elm.insertBefore( $(".active-subscription__extended").children().first() );
    //elm.css("border", "1px solid blue");
    elm.trigger('click');
    //elm.click();
  }
  else{
    //console.log(somethingToFind + " NOT found");
  }
}

// when the add AddProductsButton is clicked
// wait a little for the DOM to refresh
// try to find AddLineItemsExitButton
// and then add eventListener
function rk_bsubAddProductsButtonClicked(){
  //console.log('\nrk_bsubAddProductsButtonClicked, waiting...');
  setTimeout(function() {
    //console.log('\n****\nrk_bsubAddProductsButtonClicked\n****\n');   //  your code here
    var elm = $(".bsub__AddLineItemsFlow-module__exit");
    //elm.css("border", "3px solid red");
    elm.on("click", rk_bsubAddLineItemsExitButtonClicked);//onone
  }, 100);// wait 0.1secs for the DOM to update
}


function rk_bsubAddLineItemsExitButtonClicked(){
  //console.log('\nrk_bsubAddLineItemsExitButtonClicked, waiting...');
  //setTimeout(function() {
    //console.log('\n****\nrk_bsubAddLineItemsExitButtonClicked\n****\n');   //  your code here
    //rk_findInitialBsubElements();
    iBoldLoopCounter = 1;
    rk_bsubLoop();
  //}, 100)// wait 0.1secs for the DOM to update
}


// DAMA 20250707 start
const NUMTRY_BOLD = 30;// changed from 10 (3x up)
const WAITPERIOD_BOLD = 500;// changed from 1500 (3x down)   
var iBoldLoopCounter = 1;                  //  set your counter to 1
function rk_bsubLoop() {         //  create a recursive loop function (remember to set stop conditions)
    setTimeout(function() {   //  call a 3s setTimeout when the loop is called
      //console.log('\n****\nhello ' + iBoldLoopCounter + '\n****\n');   //  your code here
      rk_findInitialBsubElements();
      iBoldLoopCounter++;                    //  increment the counter
      if (iBoldLoopCounter < NUMTRY_BOLD) {           //  if the counter < NUMTRY_BOLD, call the loop function
        rk_bsubLoop();             //  ..  again which will trigger another 
        if(iBoldLoopCounter == NUMTRY_BOLD-1){ // for the last iteration try to rearrange the accordion items
          var listOfItems = $('.active-subscription__extended');
          var i = 0;
          listOfItems.each(function(){
            i++;
             var title = $(this).text();
              //console.log( "\n" + i + " " + $(this).text() );
             if(title.includes('Products in my subscription')){
               //console.log( '\nYAY' );
             }
          })
        }
      }
    //}                       //  ..  setTimeout()
  }, WAITPERIOD_BOLD)
}

var gvBoldSettingSavedStatus = false;
var gvBoldSettingSavedLoopCounter = 0;

function rk_clickSaveNextOrderDateButton(){
  gvBoldSettingSavedStatus = false;// remember to reset before start
  gvBoldSettingSavedLoopCounter = 0;// remember to reset before start
  rk_bsubSaveNextOrderDateLoop();
}      

// **************
// Save changes / Gem ændringer
// try to capture the updated DOM after changes have been saved to Bold Server and the Bold server has returned
// Wait 0,1secs between each loop
// Try a maximum of x=500 times
// Once the DOM is updated reset the functionality (i.e. eventListeners)
// also apply this functionality for pressing [X] in the "add new product to subscription" accordion ("bsub__AddLineItemsFlow-module__exit")
// **************
function rk_bsubSaveNextOrderDateLoop() {         //  create a loop function

  //console.log('hello rk_bsubSaveNextOrderDateLoop ' + gvBoldSettingSavedLoopCounter, gvBoldSettingSavedStatus, gvBoldSettingSavedLoopCounter);   //  your code here
    
    setTimeout(function() {   //  call a setTimeout with a timeout of WAITPERIOD_BOLD ms when the loop is called
      if(gvBoldSettingSavedStatus == true ){return 1;} // break recursive fn with success
      if(gvBoldSettingSavedLoopCounter > 500){ return -(gvBoldSettingSavedLoopCounter); } // break recursive fn with failure (max 20? tries, should be balanced with setTimeOut interval)
      
      rk_bsubSaveNextOrderDateLoop();             //  ..  again which will trigger another             
      gvBoldSettingSavedLoopCounter++;             
      //console.log('\n****\nXXXXhello rk_bsubSaveNextOrderDateLoop ' + gvBoldSettingSavedLoopCounter + '\n****\n');   //  your code here
      var elm = $('.next-order-date-edit-resume-button');
      if( elm.length > 0 ){
        gvBoldSettingSavedStatus = true;
        //console.log( 'elm found iteration: ' + gvBoldSettingSavedLoopCounter);
        //elm.css("border", "3px solid red");//jQuery
        elm.children().first().on("click", rk_bsubNextOrderDateEditResumeButtonClickListener);
        //elm.children().first().on("click", rk_clickSaveNextOrderDateButton);
        return 1;
      }

    }, 100)
}


// try to find the "Add Products" button
// add a click eventlistener to the "Add Products" button
// when the "Add Products" button is clicked, 
// wait a little bit to find the Line item "Exit button" (i.e "[x]" in the upper right hand corner of the Add products accordion)
// - class: bsub__AddLineItemsFlow-module__exit
// - use an interval of 0.1sec and 20 iterations. Should happen instanously. 
// then add an eventListener to the "Exit Button"
// the "Exit Button" should do the same as when page is initially loaded and rk_findInitialBsubElements() is called:
// 1) remove shipping adress
// 2) remove payment details
// 3) remove order now button
// 4) reorder the accordion
function clickAddLineItemsFlowModuleExitButton(){
  //gvBoldSettingSavedStatus = false;// remember to reset before start
  //gvBoldSettingSavedLoopCounter = 0;// remember to reset before start
  //rk_bsubSaveNextOrderDateLoop();
}      



// *****************       
// Update future orders / Rediger kommende bestillinger     
// add special Eventlistener
// ***************** 
function rk_applyAddedFunctionalityTonNextOrderDateEditResumeButton(){
    var elm = $(".next-order-date-edit-resume-button");
    //elm.css("border", "3px solid red");//jQuery
    elm.children().first().on("click", rk_bsubNextOrderDateEditResumeButtonClickListener);
}

// ***************** 
// Update future orders / Rediger kommende bestillinger (reset) 
// ***************** 
function rk_resetNextOrderDateEditResumeButtonFunctionality(){
  //console.log("rk_resetNextOrderDateEditResumeButtonFunctionality");
    //elm.children().first().on("click", rk_bsubNextOrderDateEditResumeButtonClickListener);
    setTimeout(function() {   //  call a 0,5s setTimeout when the loop is called
      rk_applyAddedFunctionalityTonNextOrderDateEditResumeButton();
    }, 50) // wait for 0.05 seconds before checking, so the DOM has time to update  
}
      
// ***************** 
// next-order-date-edit-resume-button
//  $( '.stx-field.stx-field--with-radio-field' );      
// ***************** 
function rk_bsubNextOrderDateEditResumeButtonClickListener(event){
    //console.log("You've clicked: rk_bsubNextOrderDateEditResumeButtonClickListener" + event.target.nodeName);
    setTimeout(function() {   //  call a 0.05s setTimeout when the loop is called
      // radio buttons container***********
      var elm = $( '.stx-field.stx-field--with-radio-field' );
      //elm.css("border", "3px solid black");
      //elm = $( '.text-button' );
      var i = 0;
      
      // each radio button***********
      elm.each(function(){
        //if( $(this).attr('id').toLowerCase().includes("swap-product-button")){
        //console.log(i);//"\n" + 
        var e = $(this).children().first().children().first();
        
        // set all to unchecked
        if( e.hasClass('stx-radio--is-checked')){
          e.removeClass('stx-radio--is-checked');
          e.children().first().attr('aria-checked', false);
          e.children().first().removeAttr('checked');
          e.children().first().prop('checked', false);
        }
        
        // only keep the second element and make it checked;("Opdater alle kommende bestillingsdatoer udfra den valgte dato")
        if( i === 1){ 
          e.children().first().attr('aria-checked', 'true');
          e.addClass('stx-radio--is-checked');
          e.children().first().trigger('click');
        } else {
          $(this).css("display", "none");
        }
        i++;
      });
      //var e = $('.bsub__change-next-order-settings-container__btns').children().first().next();
      //console.log(e.attr('class'));

      elm = $(".bsub__change-next-order-settings-container__btns");
      
      // **************
      // save button
      // **************
      //elm.children().first().css("border", "3px solid red");
      elm.children().first().on("click", rk_clickSaveNextOrderDateButton );

      // **************
      // cancel button
      // **************
      //elm.children().first().next().css("border", "3px solid red");
      elm.children().first().next().on("click", rk_resetNextOrderDateEditResumeButtonFunctionality );
      
    }, 50); // wait for 0.05 seconds before checking, so the DOM has time to update
    
  
  }

      
// myBoldOnClickFunction
// Some elements from the Bold Subscription module only become part of the DOM at runtime when, for instance, an accordion is unfolded.
// To get at hold of these elements at runtime a strategy can be to apply an "OnClick" eventlistener to the accordion title bar in the DOM, and 
// subsequently use jQuery to try to get hold of any new accordion elements in the DOM.
  function rk_bsubProductsInMySubscriptionAccordionClickListener(event){
    //console.log("You've clicked: " + event.target.nodeName);
    //console.log("rk_bsubProductsInMySubscriptionAccordionClickListener Clicked!");
    
    setTimeout(function() {   
      //var elm = $(data-bold-component-id="products-panel"  
      var elm1 =  $('[data-bold-component-id="products-panel"]');
      //elm1.css("border", "3px solid red");

      elm1 = elm1.children().first().next().children().first();
      //elm1.css("border", "3px solid red");//jQuery
      elm1.on("click", rk_bsubAddProductsButtonClicked); // onone

      // ****************        
      // edit button
      // ****************        
      var elm = $( '#products_panel_action_button' );
      //elm.css("border", "3px solid red");
      elm.css("display", "none");
      elm = $( '.text-button' );
      elm.each(function(){
        // ****************        
        // swap buttons
        // ****************        
        if( $(this).attr('id').toLowerCase().includes("swap-product-button")){
          //console.log($(this).attr('id'));
          //$(this).css("border", "3px solid purple");
          $(this).css("display", "none");
        };
      })
    }, 50) // wait for 0.05 seconds before checking, so the DOM has time to update
  }


 